<template>
    <div class="ml-auto mr-auto" style="max-width: 400px;">
        <form
            id="wfhSignInForm"
            @submit="submitForm"
        >
            <div class="mt-30">
                <label
                    for="email"
                    class="wfh-form-label"
                    :class="{'text-danger': emailError}"
                >
                    Email Address
                </label>
                <input
                    class="form-control wfh-input-box"
                    :class="{'is-invalid': emailError}"
                    style="background-image: none !important;"
                    type="email"
                    id="email"
                    v-model="email"
                    placeholder="josh@work.com"/>
                <span v-if="emailError" v-text="emailError" class="wfh-err-label"></span>
            </div>
            <div class="mt-30 position-relative">
                <label
                    for="password"
                    class="wfh-form-label"
                    :class="{'text-danger': passwordError}"
                >
                    Password
                </label>
                <input
                    ref="passwordField"
                    class="form-control wfh-input-box"
                    :class="{'is-invalid': passwordError}"
                    style="background-image: none !important;"
                    type="password"
                    id="password"
                    v-model="password"
                    placeholder="Minimum 8 characters"/>
                <button
                    class="btn btn-link position-absolute"
                    style="padding: 0 !important;top: 37px;right: 16px"
                    @click="togglePasswordView"
                >
                    <i class="fas"
                       style="color: #303030;"
                       :class="{'fa-eye': !viewPassword, 'fa-eye-slash': viewPassword}"
                    ></i>
                </button>
                <span v-if="passwordError" v-text="passwordError" class="wfh-err-label"></span>
            </div>
            <div class="mt-2">
                <a :href="'/password/reset'" class="wfh-link">Forgot Password</a>
            </div>

            <div class="text-center">
                <button
                    type="submit"
                    :disabled="!formCompleted || loading"
                    class="btn wfh-btn-primary position-relative"
                    style="margin-top: 30px;"
                >
                    <span
                        class="spinner-border position-absolute"
                        role="status"
                        style="left: 16px;top: 10px;"
                        v-show="loading"
                    >
                        <span class="sr-only">Loading...</span>
                    </span>
                    Sign-in
                </button>
            </div>
        </form>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                email: null,
                password: null,
                emailError: null,
                passwordError: null,
                viewPassword: false,
                loading: false
            }
        },

        computed: {
            formCompleted() {
                return this.email && this.password;
            }
        },

        methods: {
            async submitForm(e) {
                this.loading = true;
                e.preventDefault();
                this.resetValidation();

                if (this.validateForm()) {
                    try {
                        await axios.post('/login', {
                            email: this.email,
                            password: this.password
                        });

                        location.href = '/dashboard';
                    } catch (e) {
                        this.emailError = 'Your email and password does not match';
                    }
                }

                this.loading = false;
            },

            togglePasswordView(e) {
                this.viewPassword = !this.viewPassword;
                this.$refs['passwordField'].type = this.viewPassword ? 'text' : 'password';
                e.preventDefault();
            },

            validateForm() {
                const emailReg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                let errCount = 0;

                if (this.password.length < 8) {
                    this.passwordError = 'Password is too short';
                    errCount++;
                }

                if (!emailReg.test(this.email)) {
                    this.emailError = 'Invalid email address please try again';
                    errCount++;
                }

                return errCount === 0;
            },

            resetValidation() {
                this.passwordError = null;
                this.emailError = null;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .mt-30 {
        margin-top: 30px;
    }
</style>
